export default class Strings {
  static mobileNumberWithoutCode = (mobile: string) => {
    if (mobile) {
      const thaiCode = new RegExp(/^\+66/)
      const isFoundCode = thaiCode.test(mobile)
      return isFoundCode ? mobile.replace(thaiCode, '0') : mobile
    }
    return mobile
  }

  static mobileNumberMasked(mobile: string) {
    if (mobile != null && mobile.length == 10) {
      return `${mobile.substring(0, 2)}*-***-*${mobile.substring(7, mobile.length)}`
    }
    return mobile
  }
}
